import React, { useState, useEffect } from 'react';
import { Spin, Alert, Button } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import mammoth from 'mammoth';

const DocxFilePreview = ({ fileUrl }) => {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDocxContent = async () => {
      try {
        setLoading(true);
        
        const response = await fetch(fileUrl);
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const arrayBuffer = await response.arrayBuffer();
        
        const result = await mammoth.convertToHtml({ arrayBuffer });
        setContent(result.value);
        
        if (result.messages.length > 0) {
          console.log('Mammoth conversion messages:', result.messages);
        }
      } catch (err) {
        console.error('Error loading DOCX:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (fileUrl) {
      fetchDocxContent();
    }
  }, [fileUrl]);

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = fileUrl.split('/').pop() || 'document.docx';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '40px' }}>
        <Spin size="large" />
        <p style={{ marginTop: '16px', color: '#666' }}>Loading DOCX file...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: '20px' }}>
        <Alert
          message="Error loading DOCX file"
          description={
            <div>
              <p>{error}</p>
              <Button 
                type="primary" 
                icon={<DownloadOutlined />} 
                onClick={handleDownload}
                size="small"
                style={{ marginTop: '10px' }}
              >
                Download to view
              </Button>
            </div>
          }
          type="error"
          showIcon
        />
      </div>
    );
  }

  return (
    <div style={{ padding: '20px' }}>
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        marginBottom: '16px',
        paddingBottom: '12px',
        borderBottom: '1px solid #e8e8e8'
      }}>
        <span style={{ fontSize: '12px', color: '#666' }}>
          DOCX Preview (formatting may vary)
        </span>
        <Button 
          size="small" 
          icon={<DownloadOutlined />} 
          onClick={handleDownload}
        >
          Download
        </Button>
      </div>
      
      <div 
        style={{ 
          maxHeight: '400px', 
          overflowY: 'auto',
          backgroundColor: '#fff',
          border: '1px solid #e8e8e8',
          borderRadius: '4px',
          padding: '20px',
          fontFamily: 'Arial, sans-serif',
          fontSize: '14px',
          lineHeight: '1.6'
        }}
        dangerouslySetInnerHTML={{ __html: content || 'No content to display' }}
      />
    </div>
  );
};

export default DocxFilePreview;